module.exports = __webpack_public_path__ + "img/circuit-connector-logistic-animation.a2b3c9a8.png";